import { Steps, WizzardHeader } from '@/components'
import { AppLoading } from '@/components/AppLoading'
import { Step1 } from '@/containers/steps/poleas/step1/Step1'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { SidebarProvider } from '@/context/SidebarContext'
import { StepsProvider } from '@/context/StepsContext'
import { WizzardHeaderProvider } from '@/context/WizzardHeaderContext'
import { PageWrapper } from '@/layouts/components/PageWrapper'
import { Sidebar } from '@/layouts/components/Sidebar'
import type { InsuranceParamsDto } from 'BrokerTsLib/src/dtos'


export function Step1Page() {
  return (
    <StepsProvider currentStepId={1}>
      <SidebarProvider>
        <WizzardHeaderProvider>
          <Step1Content />
        </WizzardHeaderProvider>
      </SidebarProvider>
    </StepsProvider>
  )
}

const Step1Content = () => {
  const { insuranceParams } = useInsuranceParams()

  return (
    <>
      {(!insuranceParams) && <AppLoading />}
      {insuranceParams &&
        <PageWrapper
          steps={<Steps />}
          header={<WizzardHeader />}
          sidebar={<Sidebar />}
          contentProps={{
            sx: {
              pt: { base: 0, md: 0 },
            },
          }}
        >
          <Step1
            type={insuranceParams?.generalParams?.paramsTypeId}
            data={insuranceParams as InsuranceParamsDto} />

        </PageWrapper>
      }
    </>
  )
}
